export interface ISwapCounts {
    all: number,
    stalled: number,
    offers: number,
    crossMatching: number,
    logistics: number,
    kickoff: number,
    inProcess: number,
    kflId: number,
    transplanted: number,
    shield: number,
    swapTracker: number,
    oneWayTracker: number
}